import { TEvent } from "./Emitter";

export interface IError<T = {}> {
	type: T;
	statusCode: number;
	message: string;
}
export class MyDispatcher<TPayload> {
	private events: TEvent<unknown>[] = [];
	private broadcast = new TEvent<unknown>();

	onfunction<T>(action: ((...args: any[]) => Promise<T>), cb: (data: T) => void): MyDispatcher<TPayload> {

		const actionNumber = (<any>action).actionType;

		if (this.events[actionNumber] == null)
			this.events[actionNumber] = new TEvent();

		this.events[actionNumber].register((payload: T) => cb(payload));

		return this;
	}

	dispatch(action: { actionType: number, data?: any, response?: any }) {
		this.events[action.actionType]?.emit(action.data)
		this.broadcast.emit(action);
	}

	register(action: (data: any) => void) {
		this.broadcast.register(data => action(data));
	}
}

export var Dispatcher = new MyDispatcher();
export default Dispatcher;